export default __webpack_public_path__ + "static/media/nz.42a3bb27.svg";